export default __webpack_public_path__ + "static/consumerdrop-ec2ae17d78dae3148dcae1317951ee2d.png";